import Http from "./Http";

export class CardsService extends Http {
  /**
   * Add new payment card
   * @param {Object} body
   * @param {string} body.cardToken
   */
  addCard(body) {
    return this.post(`/cards`, body);
  }

  /**
   * Get list of payment cards
   */
  getCards() {
    return this.get("/cards");
  }

  /**
   * Get payment card details
   * @param {number} id
   */
  getCardDetails(id) {
    return this.get(`/cards/${id}`);
  }

  /**
   * Delete payment card
   * @param {number} id
   */
  deleteCard(id) {
    return this.delete(`/cards/${id}`);
  }

  /**
   * Set default user`s payment card
   * @param {number} id
   */
  setDefaultCard(id) {
    return this.patch(`/cards/${id}/is-default`);
  }
}

export default new CardsService();
